import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {PermissionsService} from "../../services/permissions/permissions.service";

@Component({
  selector: 'app-opt-in-profile-detail-modal',
  templateUrl: './opt-in-profile-detail-modal.component.pug',
  styleUrls: ['./opt-in-profile-detail-modal.component.scss'],
  standalone: false
})
export class OptInProfileDetailModalComponent implements OnInit {
  details: any;
  status: any;
  potentialCandidateData: any;
  exEmployeeData: any;

  constructor(public bsModalRef: BsModalRef, private permissions: PermissionsService) { }

  ngOnInit(): void {
  }

  closeModal(){
    this.bsModalRef.hide();
  }

  checkOverflow(element: any): boolean {
    return element.offsetWidth < element.scrollWidth;
  }

}
